export default "__VITE_ASSET__2c2a1476__"